import React from "react";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import ReactPaginate from "react-paginate";

interface PropTypes {
  page: number;
  handlePageClick: (e: { selected: number }) => void;
  currentPage?: number;
}

function Pagination({ page, handlePageClick, currentPage = 1 }: PropTypes) {
  return (
    <div className="w-full flex justify-center items-center ">
      <ReactPaginate
        containerClassName="flex items-center gap-1"
        pageCount={page}
        forcePage={currentPage - 1}
        onPageChange={handlePageClick}
        pageRangeDisplayed={4}
        marginPagesDisplayed={0}

        pageClassName="pagination-button"
        activeLinkClassName="bg-primary text-white rounded-sm"

        previousClassName="pagination-button"
        nextClassName="pagination-button"

        previousLabel={
          <div className="w-2 h-6 flex items-center justify-center overflow-visible">
            <AiOutlineArrowLeft className="w-4 h-4 scale-150" />
          </div>

        }
        nextLabel={
          <div className="w-2 h-6 flex items-center justify-center overflow-visible">
            <AiOutlineArrowRight className="w-4 h-4 scale-150" />
          </div>
        }
      />
    </div>
  );
}

export default Pagination;
